import React from 'react';
import useToggleStateOnUser from 'App/hooks/useToggleStateOnUser';
import defaultHeaderRenderer from './defaultHeaderRenderer';
import PropTypes from 'prop-types';

const propTypes = {
    renderHeader: PropTypes.func,
    children: PropTypes.node,
    stateKey: PropTypes.string.isRequired,
    headerText: PropTypes.string,
};

const defaultProps = {
    renderHeader: defaultHeaderRenderer,
    headerText: 'Heading',
    children: null,
};

function SidebarGroup({ headerText, renderHeader, children, stateKey }) {
    const [isOpen, toggleOpen] = useToggleStateOnUser(stateKey);

    return (
        <div className="sidebar-group">
            <button type="button" onClick={toggleOpen}>
                {renderHeader({ headerText, isOpen })}
            </button>
            <div
                aria-expanded={isOpen}
                aria-controls="page-sidebar-menu"
                title={`${isOpen ? 'Collapse' : 'Expand'} Group`}
                aria-label={`${isOpen ? 'Collapse' : 'Expand'} Group`}
            >
                {isOpen ? children : null}
            </div>
        </div>
    );
}

SidebarGroup.propTypes = propTypes;
SidebarGroup.defaultProps = defaultProps;

export default SidebarGroup;
